<template>
  <div v-if="url" class="trbo-a-image">
    <img :src="url" :alt="altText" class="trbo-a-image__media">
  </div>
</template>

<script>
export default {
  props: {
    question: {
      type: Object, // WizardPage
      required: true
    },
    questionData: {
      type: Object, // WizardPageData<ImageData>
      required: true
    }
  },
  computed: {
    url () {
      return this.questionData.imageUrl
    },
    altText () {
      return this.questionData.imageAltText || ''
    }
  }
}
</script>

<style scoped src="./image.scss" />
